//↓#へ移動↓
jQuery(function() {
    $("a[href^=#]").click(function(){
        var elmID = $(this).attr("href");
        var posi = 0;
         
        if($(elmID).size()){
            posi = $(elmID).offset().top -0;
            BodySlider(posi);
            return false;
        }
    });
    function BodySlider(HashOffset){
        $("html,body").animate({
            scrollTop: HashOffset
        }, 400);
    }
});

//↓トップへ戻る↓
jQuery(function() {
    var topBtn = $('.page-top');    
    topBtn.hide();
    //スクロールが100に達したらボタン表示
    $(window).scroll(function () {
        if ($(this).scrollTop() > 500) {
            topBtn.fadeIn();
        } else {
            topBtn.fadeOut();
        }
    });
});



/*==============================================
  Menu
==============================================*/

jQuery(function($){

  var scrollpos;
  $('.g-nav-btn').on("click", function() {
    if ($('#g-nav').hasClass('is-show') == false) {
      scrollpos = $(window).scrollTop();
      $('body').addClass('is-fixed').css({'top': -scrollpos});        
      $('#g-nav').addClass('is-show');
    } else {
      $('body').removeClass('is-fixed').css({'top': 0});
      window.scrollTo( 0 , scrollpos );
      $('#g-nav').removeClass('is-show');
    }  
  });  

  $('.close').on('click', function() {
    $('body').removeClass('is-fixed').css({'top': 0});
    window.scrollTo( 0 , scrollpos );
    $('#g-nav').removeClass('is-show');
  });

  $('.g-nav-inner').on('click', function() {
    $('body').removeClass('is-fixed').css({'top': 0});
    window.scrollTo( 0 , scrollpos );
    $('#g-nav').removeClass('is-show');
  });
});

$(document).ready(function(){
			$('.slider01').slick({
				autoplay: true,
				autoplaySpeed: 7000,
				speed: 1000,
				pauseOnHover: false,
				pauseOnDotsHover: false,
				appendArrows: $('#s-arrow01'),
			});
			$('.slider02').slick({
				autoplay: true,
				autoplaySpeed: 7000,
				speed: 1000,
				pauseOnHover: false,
				pauseOnDotsHover: false,
				appendArrows: $('#s-arrow02'),
			});
			$('.slider03').slick({
				autoplay: true,
				autoplaySpeed: 8000,
				speed: 1000,
				pauseOnHover: false,
				pauseOnDotsHover: false,
				appendArrows: $('#s-arrow03'),
			});
			$('.slider04').slick({
				autoplay: true,
				autoplaySpeed: 8000,
				speed: 1000,
				pauseOnHover: false,
				pauseOnDotsHover: false,
				appendArrows: $('#s-arrow04'),
			});
			$('.slider05').slick({
				autoplay: true,
				autoplaySpeed: 8000,
				speed: 1000,
				pauseOnHover: false,
				pauseOnDotsHover: false,
				appendArrows: $('#s-arrow05'),
			});
			$('.slider06').slick({
				autoplay: true,
				autoplaySpeed: 8000,
				speed: 1000,
				pauseOnHover: false,
				pauseOnDotsHover: false,
				appendArrows: $('#s-arrow06'),
			});
			$('.slider07').slick({
				autoplay: true,
				autoplaySpeed: 8000,
				speed: 1000,
				pauseOnHover: false,
				pauseOnDotsHover: false,
				appendArrows: $('#s-arrow07'),
			});
			$('.slider08').slick({
				autoplay: true,
				autoplaySpeed: 8000,
				speed: 1000,
				pauseOnHover: false,
				pauseOnDotsHover: false,
				appendArrows: $('#s-arrow08'),
			});
			$('.slider09').slick({
				autoplay: true,
				autoplaySpeed: 8000,
				speed: 1000,
				pauseOnHover: false,
				pauseOnDotsHover: false,
				appendArrows: $('#s-arrow09'),
			});
			$('.slider10').slick({
				autoplay: true,
				autoplaySpeed: 8000,
				speed: 1000,
				pauseOnHover: false,
				pauseOnDotsHover: false,
				appendArrows: $('#s-arrow10'),
			});
			$('.slider11').slick({
				autoplay: true,
				autoplaySpeed: 8000,
				speed: 1000,
				pauseOnHover: false,
				pauseOnDotsHover: false,
				appendArrows: $('#s-arrow11'),
			});
			$('.slider12').slick({
				autoplay: true,
				autoplaySpeed: 8000,
				speed: 1000,
				pauseOnHover: false,
				pauseOnDotsHover: false,
				appendArrows: $('#s-arrow12'),
			});
			$('.slider13').slick({
				autoplay: true,
				autoplaySpeed: 8000,
				speed: 1000,
				pauseOnHover: false,
				pauseOnDotsHover: false,
				appendArrows: $('#s-arrow13'),
			});
			$('.slider14').slick({
				autoplay: true,
				autoplaySpeed: 8000,
				speed: 1000,
				pauseOnHover: false,
				pauseOnDotsHover: false,
				infinite: true,
				centerMode: false,
				slidesToShow: 4,
				slidesToScroll: 1,
				variableWidth: true,
				lazyLoad: 'progressive',
				appendArrows: $('#s-arrow14'),
			});
		});

$(function(){
      // setViewport
      spView = 'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no';
      tbView = 'width=1176px,maximum-scale=2.0,user-scalable=1';

      if(navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('iPod') > 0 || (navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') > 0)){
          $('head').prepend('<meta name="viewport" content="' + spView + '" id="viewport">');
      } else if(navigator.userAgent.indexOf('iPad') > 0 || (navigator.userAgent.indexOf('Android') > 0 && navigator.userAgent.indexOf('Mobile') == -1) || navigator.userAgent.indexOf('A1_07') > 0 || navigator.userAgent.indexOf('SC-01C') > 0){
          $('head').prepend('<meta name="viewport" content="' + tbView + '" id="viewport">');
      } 
  });
